export const CARD_ALIAS_FALLBACK = 'Tarjeta';
export const CARD_LABEL_UNASSIGNED = 'Sin Asignar';

export function formatCardAliasForDisplay(alias: string | undefined | null): string {
    if (alias == null) return CARD_ALIAS_FALLBACK;
    const trimmed = String(alias).trim();
    if (!trimmed || trimmed === 'N/A') return CARD_ALIAS_FALLBACK;
    return trimmed;
}

export function formatCardLabelForDisplay(tag: string | undefined | null): string {
    if (tag == null) return CARD_LABEL_UNASSIGNED;
    const trimmed = String(tag).trim();
    if (!trimmed || trimmed === 'N/A') return CARD_LABEL_UNASSIGNED;
    return trimmed;
}

export function rawAliasForEdit(alias: string | undefined | null): string {
    if (alias == null) return '';
    const trimmed = String(alias).trim();
    if (!trimmed || trimmed === 'N/A') return '';
    return trimmed;
}
